module.exports = __webpack_public_path__ + "static/media/location-pin-green.b809f014.svg";